<template>
    <div class="">
        <div class="row no-gutters py-3">
            <div class="col-sm-6 pr-5 pl-4 company-form-box-title">Nominee Information</div>
            <template>
                <div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title" @click="addNew()">
                    <button class="edit-icon"><i class="fa fa-plus"></i></button> 
                </div>
            </template>
        </div>
        {{ checkPercentage }}
        <b-overlay :show="showoverlay_list" rounded="sm">
            <div v-if="nominee_list.length > 0" >    
                <div class="bank-info-inner" v-for="(bank, index)  in nominee_list" :key="bank.id">
                    <div v-if="index == 0">  
                        <ul class="bank-info row pl-4" :class="{ 'border-top' : bi==1}"> 
                            <li class="m-0">
                                <div class="separator-title my-2 col-12">General Information of Nominee # {{ getind(index) }}</div>
                                <div class="title col-6">Name</div>
                                <div class="text col-5">{{bank.name}}</div>
                                <div class="action col-1 pr-0">
                                    
                                    <b-button-toolbar class="float-right position-relative">
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                        <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                            <b-button-group class="mt-n2">
                                                <b-button class="border-0 rounded py-0" variant="outline-secondary"  title="Edit Bank Account Info" @click="editBankInfo(bank.id)">
                                                    <b-icon icon="pencil-fill" aria-hidden="true" ></b-icon> Edit
                                                </b-button>
                                                <b-button class="border-0 rounded py-0" variant="outline-secondary" title="Delete Bank Account Info" @click="deleteBankInfo(bank.id)">
                                                    <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                                                </b-button>
                                            </b-button-group>
                                        </div>
                                    </b-button-toolbar>
                                </div>
                            </li>

                            <li class="m-0">
                                <div class="title col-6">Relationship with employee</div>
                                <div class="text col-6"><template v-if="bank.bank_name != 'null'">{{bank.relationship_employee}}</template></div>
                            </li>
                            <li class="m-0">
                                <div class="title col-6">Contact Number</div>
                                <div class="text col-6"><template v-if="bank.bank_name != 'null'">{{bank.contact}}</template></div>
                            </li>
                            <li class="m-0">
                                <div class="title col-6">NID Number/ Passport</div>
                                <div class="text col-6"><template v-if="bank.bank_name != 'null'">{{bank.identification_file }}</template></div>
                            </li>
                            <li class="m-0">
                                <div class="title col-6">Distribution Percentage</div>
                                <div class="text col-6"><template v-if="bank.bank_name != 'null'">{{bank.distribution_percentage}} %</template></div>
                            </li>

                            <template v-if="bank.beneficiary_name != 'null' && bank.beneficiary_name != ''">

                                <li class="m-0">
                                    <div class="separator-title my-2 col-12">Bank Information of Nominee # {{ getind(index) }}</div>
                                    <div class="title col-6">Beneficiary Name</div>
                                    <div class="text col-6"><template v-if="bank.beneficiary_name != 'null'">{{bank.beneficiary_name}}</template></div>
                                </li>

                                <li class="m-0">
                                    <div class="title col-6">Bank Name</div>
                                    <div class="text col-6"><template v-if="bank.bank_name != 'null'">{{bank.bank_name}}</template></div>
                                </li>
                                <li class="m-0">
                                    <div class="title col-6">Branch Name</div>
                                    <div class="text col-6"><template v-if="bank.branch_name != 'null'">{{bank.branch_name}}</template></div>
                                </li>
                                <li class="m-0">
                                    <div class="title col-6">Bank Account No.</div>
                                    <div class="text col-6">{{bank.account_no}}</div>
                                </li>
                                <li class="m-0">
                                    <div class="title col-6" >Routing Number</div>
                                    <div class="text col-6"><template v-if="bank.routing_number != 'null'">{{bank.routing_number}}</template></div>
                                </li>
                            </template>
                            <template v-else>
                                <li class="m-0">
                                    <div class="separator-title my-2 col-12">Bank Information of Nominee # {{ getind(index) }}</div>
                                    <div class="title col-12">No information found</div>
                                </li>
                            </template>
                            
                        </ul>
                    </div>
                    <div v-else>  
                        <ul class="bank-info row pl-4" v-if="bi==1" :class="{ 'border-top' : bi==1}">
                            <li class="m-0">
                                <div class="separator-title my-2 col-12">General Information of Nominee # {{ getind(index) }}</div>
                                <div class="title col-6">Name</div>
                                <div class="text col-5">{{bank.name}}</div>
                                <div class="action col-1 pr-0">
                                    
                                    <b-button-toolbar class="float-right position-relative">
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                        <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                            <b-button-group class="mt-n2">
                                                <b-button class="border-0 rounded py-0" variant="outline-secondary"  title="Edit Bank Account Info" @click="editBankInfo(bank.id)">
                                                    <b-icon icon="pencil-fill" aria-hidden="true" ></b-icon> Edit
                                                </b-button>
                                                <b-button class="border-0 rounded py-0" variant="outline-secondary" title="Delete Bank Account Info" @click="deleteBankInfo(bank.id)">
                                                    <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                                                </b-button>
                                            </b-button-group>
                                        </div>
                                    </b-button-toolbar>
                                </div>
                            </li>

                            <li class="m-0">
                                <div class="title col-6">Relationship with employee</div>
                                <div class="text col-6"><template v-if="bank.bank_name != 'null'">{{bank.relationship_employee}}</template></div>
                            </li>
                            <li class="m-0">
                                <div class="title col-6">Contact Number</div>
                                <div class="text col-6"><template v-if="bank.bank_name != 'null'">{{bank.contact}}</template></div>
                            </li>
                            <li class="m-0">
                                <div class="title col-6">NID Number/ Passport</div>
                                <div class="text col-6"><template v-if="bank.bank_name != 'null'">{{bank.identification_file }}</template></div>
                            </li>
                            <li class="m-0">
                                <div class="title col-6">Distribution Percentage</div>
                                <div class="text col-6"><template v-if="bank.bank_name != 'null'">{{bank.distribution_percentage}} %</template></div>
                            </li>

                            <template v-if="bank.beneficiary_name != 'null' && bank.beneficiary_name != ''">

                                <li class="m-0">
                                    <div class="separator-title my-2 col-12">Bank Information of Nominee # {{ getind(index) }}</div>
                                    <div class="title col-6">Beneficiary Name</div>
                                    <div class="text col-6"><template v-if="bank.beneficiary_name != 'null'">{{bank.bank_name}}</template></div>
                                </li>

                                <li class="m-0">
                                    <div class="title col-6">Bank Name</div>
                                    <div class="text col-6"><template v-if="bank.bank_name != 'null'">{{bank.bank_name}}</template></div>
                                </li>
                                <li class="m-0">
                                    <div class="title col-6">Branch Name</div>
                                    <div class="text col-6"><template v-if="bank.branch_name != 'null'">{{bank.branch_name}}</template></div>
                                </li>
                                <li class="m-0">
                                    <div class="title col-6">Bank Account No.</div>
                                    <div class="text col-6">{{bank.account_no}}</div>
                                </li>
                                <li class="m-0">
                                    <div class="title col-6" >Routing Number</div>
                                    <div class="text col-6"><template v-if="bank.routing_number != 'null'">{{bank.routing_number}}</template></div>
                                </li>
                            </template> 
                            <template v-else>
                                <li class="m-0">
                                    <div class="separator-title my-2 col-12">Bank Information of Nominee # {{ getind(index) }}</div>
                                    <div class="title col-12">No information found</div>
                                </li>
                            </template>
                        </ul>
                    </div>

                </div>
                <template v-if="nominee_list.length > 0">
                    <div class="more-bank" v-if="bi==0">
                            <b-button class="border-0 rounded p-0" variant="outline-secondary" title="Show all" @click="showAll(1)">
                                Show All <i class="fa fa-angle-down"></i>
                            </b-button>
                    </div>
                    <div class="more-bank" v-if="bi==1">
                            <b-button class="border-0 rounded p-0" variant="outline-secondary" title="Show less" @click="showLess(0)">
                                Show Less <i class="fa fa-angle-up"></i>
                            </b-button>
                    </div> 
                </template>                 
            </div>
            <div v-else> 
                <div class="bank-info-inner px-4 ">
                    <p>No nominee information available.</p>
                </div>
            </div>
        </b-overlay>
        
        <b-modal id="bv-modal-nominee" size="lg" hide-footer title="Nominee Information">
            <b-form @submit.stop.prevent="onSubmit" >      
                             

                <ul class="list-group mb-3 " v-if='disable_msg'>           
                    <li class="list-group-item list-group-item-danger">{{disable_msg}}</li>
                </ul>
                
                <ul class="list-group mb-3 " v-if='errormsg'>           
                    <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
                </ul>
                <div class="clearfix">
                    
                    <ul class="list-group mb-3 " v-if='errormsg'>           
                        <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
                    </ul> 
                    <div class="col-md-6 float-left">              
                        <input type="hidden" v-model="fdata.id" name="id">
                        <b-form-group id="name-group" label="Nominee Name" class="required-field" label-for="name">
                            <b-form-input id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3,alpha_spaces: true}" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Nominee Name"></b-form-input>
                            <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group id="identification_file-group" label="Nominee NID Number/ Passport" class="required-field" label-for="name">
                            <b-form-input id="identification_file" name="identification_file" v-model="fdata.identification_file" v-validate="{ required: true,alpha_num: true}" :state="validateState('identification_file')" aria-describedby="identification_file-feedback" data-vv-as="Nominee NID/Passport"></b-form-input>
                            <b-form-invalid-feedback id="identification_file-feedback">{{ veeErrors.first('identification_file') }}</b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group id="distribution_percentage-group" label="Distribution Percentage" class="required-field" label-for="distribution_percentage">
                            <b-form-input id="distribution_percentage" name="distribution_percentage" v-model="fdata.distribution_percentage" v-validate="{ required: true,decimal:0,max_value:100,min_value:0}" :state="validateState('distribution_percentage')" aria-describedby="distribution_percentage-feedback" data-vv-as="Distribution Percentage"></b-form-input>
                            <b-form-invalid-feedback id="distribution_percentage-feedback">{{ veeErrors.first('distribution_percentage') }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-6 float-right">     
                        <b-form-group id="relationship_employee-group" label="Relationship with employee" class="required-field" label-for="relationship_employee">
                            <b-form-input id="relationship_employee" name="relationship_employee" v-model="fdata.relationship_employee" v-validate="{ required: true, min: 3,alpha_spaces: true}" :state="validateState('relationship_employee')" aria-describedby="relationship_employee-feedback" data-vv-as="Relationship with employee"></b-form-input>
                            <b-form-invalid-feedback id="relationship_employee-feedback">{{ veeErrors.first('relationship_employee') }}</b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group id="contact-group" label="Contact Number"  label-for="contact">
                            <b-form-input id="contact" name="contact" v-model="fdata.contact" v-validate="{ required: false, min: 11,numeric:true}" :state="validateState('contact')" aria-describedby="contact-feedback" data-vv-as="Contact Number"></b-form-input>
                            <b-form-invalid-feedback id="contact-feedback">{{ veeErrors.first('contact') }}</b-form-invalid-feedback>
                        </b-form-group>
                        
                    </div>

                    <div class="col-md-12 float-left mb-3 bank-field">
                        <div> Bank Information</div>
                    </div>
                    <div class="col-md-6 float-left">                    
                        
                        <b-form-group id="beneficiary_name-group" label="Beneficiary Name" label-for="beneficiary_name">
                            <b-form-input id="beneficiary_name" name="beneficiary_name" v-model="fdata.beneficiary_name" v-validate="{ required: false,alpha_spaces: true}" :state="validateState('beneficiary_name')" aria-describedby="beneficiary_name-feedback" data-vv-as="Beneficiary Name"></b-form-input>
                            <b-form-invalid-feedback id="beneficiary_name-feedback">{{ veeErrors.first('beneficiary_name') }}</b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group id="bank_name-group" label="Bank Name"  label-for="bank_name">
                            <b-form-select id="bank_name" name="bank_name" v-model="fdata.bank_name" v-validate="{ required: false}" :options="bank_names" :state="validateState('bank_name')" aria-describedby="bank_name-feedback" data-vv-as="Bank Name"></b-form-select>
                            <b-form-invalid-feedback id="bank_name-feedback">{{ veeErrors.first('bank_name') }}</b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group id="routing_number-group" label="Routing No." class="" label-for="routing_number">
                            <b-form-input id="routing_number" name="routing_number" v-model="fdata.routing_number" v-validate="{ numeric:true }" :state="validateState('routing_number')" aria-describedby="routing_number-feedback" data-vv-as="Routing No."></b-form-input>
                            <b-form-invalid-feedback id="routing_number-feedback">{{ veeErrors.first('routing_number') }}</b-form-invalid-feedback>
                        </b-form-group>                     
                    </div>
                    <div class="col-md-6 float-right">
                        <b-form-group id="account_no-group" label="Account No."  label-for="account_no">
                            <b-form-input id="account_no" name="account_no" v-model="fdata.account_no" v-validate="{ required: false, numeric:true }" :state="validateState('account_no')" aria-describedby="account_no-feedback" data-vv-as="Account No."></b-form-input>
                            <b-form-invalid-feedback id="account_no-feedback">{{ veeErrors.first('account_no') }}</b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group id="branch_name-group" label="Branch Name" class="" label-for="branch_name">
                            <b-form-input id="branch_name" name="branch_name" v-model="fdata.branch_name" ></b-form-input>
                        </b-form-group>
                        
                    </div> 
                    <div class="col-md-12 float-right">
                        <div class="mt-4 ml-4"> 
                            <b-button type="submit" class="btn rounded bg-light float-right py-1 mt-2 btn-primary btn-lg" :disabled="disable_submit" variant="success">Submit</b-button>
                            <!-- <b-button class="ml-2 border rounded float-right py-1 pr-5 pl-4 mt-4" variant="success" @click="resetForm()">Reset</b-button> -->
                        </div>
                    </div>               
                </div>          

            </b-form>
        </b-modal> 
        
        
    </div>
</template>


<script>
    export default{
        
        mounted() {
            
        },
        props: ['employeeid','company_id', 'flg'],
        data(){            
            
            return {
                
                banks:[],                
                bank_names: [
                    { value: null, text: "--Select--" },
                ],   
                
                showoverlay_list : false,                          
                successmsg:'',
                errormsg:[],
                fdata: {employee_id: this.employeeid,company_id: this.company_id, beneficiary_name: '', bank_name:null},

                selected_bank_id:0,
                loading:'',
                bi : 0,
                upload_file : null,
                nominee_list:[],
                disable_submit:false,
                disable_msg:'',
            }
        },
        methods:{
            
            getBankList: function()
            {
                let currentObj = this;
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/front/banklist' , {
                    params: {

                    }
                }).then(function(response){
                    currentObj.bank_names = response.data;
                    currentObj.getNomineeList();
                }.bind(this)).catch(function (error){
                    console.log(error);
                
                });

            }, 
            getind(i)
            {
                return i + 1;
            },  
            getNomineeList: function()
            {
                this.showoverlay_list = true;
                let currentObj = this;
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/front/nominee-list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    currentObj.nominee_list = response.data;
                    this.showoverlay_list = false;
                }.bind(this)).catch(function (error){
                    console.log(error);
                
                });

            }, 
            showAll :function(x)
            {
                this.bi = x;
            },
            showLess :function(x)
            {
                this.bi = x;
            },
            deleteBankInfo:function(id)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this Nominee Info.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {                    
                    if(value)
                    {                        
                        this.resetForm();
                        this.showoverlay_list = true;
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', id);
                        
                        axios.post(this.$api_url+'/front/nominee/delete', formData).then(function(response){
                        
                            this.$bvToast.toast('Nominee data deleted successfully', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });
                            this.getNomineeList();                    
                            
                            this.showoverlay_list = false;
                            
                            
                        }.bind(this))
                        .catch(function (error) 
                        {
                            currentObj.showoverlay_list = false;
                            currentObj.serverError(error);
                        }); 
                    }
                })
            },
            
            editBankInfo:function(id)
            {        
                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();
                formData.append('id', id);
                this.resetForm();
                axios.post(this.$api_url+'/front/get-nominee-info', formData).then(function(response){  
                    this.fdata = response.data;

                    if(this.fdata.branch_name == 'null')
                        this.fdata.branch_name = '';
                    
                    if(this.fdata.routing_number == 'null')
                        this.fdata.routing_number = '';

                    this.successmsg = null;
                    console.log(this.fdata);
                    this.$bvModal.show('bv-modal-nominee');  
                    
                }.bind(this)).catch(function (error){
                   console.log(error);
                
                });               
                
            },           
            
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata = {
                    id:0,
                    employee_id: this.employeeid,
                    company_id: this.company_id,
                    name:null,
                    identification_file:null,
                    relationship_employee:null,
                    beneficiary_name:null,
                    account_no: null,
                    bank_name: null,
                    routing_number:null,
                    branch_name:null,
                    swift_code:null,
                    distribution_percentage:'',
                };
                this.upload_file = null;

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            addNew()
            {
                this.resetForm();
                this.$bvModal.show('bv-modal-nominee');               
            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlay_list = true;
                    let currentObj = this;
                    e.preventDefault();
                    
                    const config = {
                        //headers: { 'content-type': 'multipart/form-data' }
                    }
                    let formData = new FormData();  
                                    
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        //console.log(`${key}: ${value}`);
                    } 
                    axios.post(this.$api_url+'/front/save-nominee-info', formData, config)
                            .then(function (response) 
                            {
                                this.$bvModal.hide('bv-modal-nominee');                               
                                this.showoverlay_list = false;
                                this.successmsg = 'Saved!';
                                this.$bvToast.toast(this.successmsg, {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });
                                this.resetForm();
                                this.getNomineeList();
                                this.$validator.reset();
                            
                            }.bind(this))
                            .catch(function (error) 
                            {
                                currentObj.showoverlay_list = false;
                                currentObj.serverError(error);
                            });
                });
            },
            updateAllEmployeeBankInfo()
            {
                axios.get(this.$api_url+'/front/update-all-employee-bank-info')
                        .then(function (response) {
                            console.log(response.data);
                        })
                        .catch(function (error) {
  
    					   currentObj.output = error;
      
    				    });
            },
            downloadFile()
            {
                let fileURL = this.$api_url + '/data/employee/'+this.fdata.company_id +'/files/'+ this.fdata.identification_file;
                
                this.download_file(fileURL); 
            },

        },
        created: function(){
            
            this.getBankList();
            
            //this.updateAllEmployeeBankInfo();
        },
        computed:
        {
        
            checkPercentage()
            {
                if(this.fdata.distribution_percentage > 0)
                { 
                    var id = this.fdata.id;
                    var pecentage = parseInt(this.fdata.distribution_percentage);
                    var cumilitive_pecentage = 0;

                    if(id == 0)
                    {
                        cumilitive_pecentage += pecentage;
                    }

                    for (let i = 0; i < this.nominee_list.length;  i++) 
                    {
                        console.log('fa-id -- '+this.nominee_list[i].id);
                        console.log('loop-id -- '+id);

                        // const obj = this.nominee_list[i];
                        // console.log(obj.name); 
                        if(this.nominee_list[i].id == id)
                        {
                            cumilitive_pecentage += parseInt(pecentage);
                        }
                        else
                        {
                            cumilitive_pecentage += parseInt(this.nominee_list[i].distribution_percentage);
                        }
                        
                    } 

                    if(cumilitive_pecentage > 100)
                    {
                        this.disable_submit = true;
                        this.disable_msg= 'Total Distribution Percentage among the nominees is grater than 100';
                    }
                    else
                    {
                        this.disable_submit = false;
                        this.disable_msg='';
                    }

                    console.log('id -- '+id);
                    console.log('fdatapecentage -- '+pecentage);
                    console.log('cumilitive_pecentage -- '+cumilitive_pecentage);
                }
            }
        }

    }
</script>
<style>
.separator-title {
	padding: 0px 15px;
	font-size: 15px;
	font-weight: 600;
	margin-bottom: 10px;
}
.bank-field {
	margin-top: 11px;
	font-size: 15px;
	font-weight: 600;
}
</style>